<template html="lang">
  <div v-if="visible" class="animation center-fixed">
    <div class="ball"></div>
    <div class="ball1"></div>
  </div>
</template>

<script>
export default {
  name: 'animation',
  props: {
    visible: {
      required: true,
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// Animation.vue?131486cf